export const MedicalRoles = [
  "Anesthesiologist",
  "Clinical Nurse Specialist",
  "CRNA/Nurse Anesthetist",
  "Dietitian",
  "Fellow",
  "Kinesiotherapist",
  "Medical Student",
  "Midwife",
  "Nurse",
  "Nurse Manager/Leader",
  "Nurse Practitioner",
  "Nursing Student",
  "Occupational Therapist",
  "Occupational Therapy Assistant",
  "Other",
  "Pharmacist",
  "Physical Therapist",
  "Physician",
  "Physician Assistant",
  "Physician Assistant Student",
  "Resident",
  "Respiratory Therapist",
  "Social Worker",
  "Speech Therapist",
];

export const NursingRoles = [
  "Clinical Assistant",
  "Clinical Nurse Specialist",
  "CRNA/Nurse Anesthetist",
  "Dietitian",
  "Kinesiotherapist",
  "Medical Assistant",
  "Midwife",
  "Nurse",
  "Nurse Manager/Leader",
  "Nurse Practitioner",
  "Occupational Therapist",
  "Occupational Therapy Assistant",
  "Other",
  "Pharmacist",
  "Physical Therapist",
  "Physical Therapy Assistant",
  "Physician Assistant",
  "Resident",
  "Respiratory Therapist",
  "Social Worker",
  "Speech Therapist",
  "Student",
];
